"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var TimeTracker = (function (_super) {
    __extends(TimeTracker, _super);
    function TimeTracker(props) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _this = _super.apply(this, __spreadArrays([props], args)) || this;
        _this.timeUpdateCallBack = function () {
            _this.props.onTimeUpdate
                ? _this.props.onTimeUpdate(_this.state.value, _this.state.start)
                : null;
        };
        _this.toggleTracker = function (event, state) {
            _this.setState(function (prevState) {
                if (state === true || (prevState.start === null && state !== false)) {
                    _this.intervalId = setInterval(_this.updateValue, 1000);
                    return {
                        start: Math.floor(Date.now() / 1000),
                    };
                }
                else {
                    clearInterval(_this.intervalId);
                    return {
                        start: null,
                    };
                }
            }, _this.timeUpdateCallBack);
        };
        _this.updateValue = function () {
            _this.setState(function (prevState) { return ({
                value: prevState.value + 1,
                storedValue: _this.valueToString(prevState.value + 1),
            }); }, _this.timeUpdateCallBack);
        };
        _this.handleInputClick = function (event) {
            _this.toggleTracker(null, false);
        };
        _this.handleInputBlur = function (event) {
            var elementValue = event.target.value;
            var elementPieces = elementValue.split(':');
            if (elementPieces.length === 3) {
                var builtValue = +elementPieces.pop();
                builtValue += 60 * +elementPieces.pop();
                builtValue += 3600 * +elementPieces.pop();
                _this.setState({ value: builtValue }, _this.timeUpdateCallBack);
            }
            else {
                _this.setState(function (prevState) { return ({
                    storedValue: _this.valueToString(prevState.value),
                }); });
            }
        };
        _this.handleInputChange = function (event) {
            _this.setState({ storedValue: event.target.value });
        };
        _this.setTimeTrackerState = function (value, start) {
            if (typeof start === 'number') {
                clearInterval(_this.intervalId);
                if (start >= 0) {
                    _this.intervalId = setInterval(_this.updateValue, 1000);
                }
            }
            _this.setState(function (prevState) { return ({
                value: value,
                storedValue: _this.valueToString(value),
                start: typeof start === 'number'
                    ? start >= 0
                        ? start
                        : null
                    : prevState.start,
            }); });
        };
        if (typeof props.initialStartTimestamp === 'number') {
            clearInterval(_this.intervalId);
            if (props.initialStartTimestamp >= 0) {
                _this.intervalId = setInterval(_this.updateValue, 1000);
            }
        }
        _this.state = {
            value: props.initialValue || 0,
            storedValue: _this.valueToString(props.initialValue || 0),
            start: typeof props.initialStartTimestamp === 'number' &&
                props.initialStartTimestamp >= 0
                ? props.initialStartTimestamp
                : null,
        };
        return _this;
    }
    TimeTracker.prototype.componentWillUnmount = function () {
        clearInterval(this.intervalId);
    };
    TimeTracker.prototype.valueToString = function (value) {
        var hours = Math.floor(value / 3600);
        var minutes = String(Math.floor((value % 3600) / 60)).padStart(2, '0');
        var seconds = String((value % 3600) % 60).padStart(2, '0');
        return hours + ":" + minutes + ":" + seconds;
    };
    TimeTracker.prototype.render = function () {
        var _a = this.state, storedValue = _a.storedValue, start = _a.start;
        var _b = this.props, startText = _b.startText, stopText = _b.stopText, wrapClass = _b.wrapClass, inputClass = _b.inputClass, buttonClass = _b.buttonClass, wrapStyle = _b.wrapStyle, inputStyle = _b.inputStyle, buttonStyle = _b.buttonStyle;
        return (React.createElement("div", { className: wrapClass || 'time-tracker-wrap', style: wrapStyle },
            React.createElement("input", { className: inputClass || 'time-tracker-input', style: inputStyle, type: "text", value: storedValue, onMouseDown: this.handleInputClick, onBlur: this.handleInputBlur, onChange: this.handleInputChange }),
            React.createElement("button", { onClick: this.toggleTracker, type: "button", className: buttonClass || 'time-tracker-button', style: buttonStyle }, start === null ? startText || 'Start' : stopText || 'Stop')));
    };
    return TimeTracker;
}(React.Component));
exports.default = TimeTracker;
//# sourceMappingURL=TimeTracker.js.map